// extracted by mini-css-extract-plugin
module.exports = {"inputStyle":"KeepTime__inputStyle__y7Zwp"};